// extracted by mini-css-extract-plugin
export default {"future":"LessonBulb_future__Mu94k","past":"LessonBulb_past__iuee- LessonBulb_future__Mu94k","small":"LessonBulb_small__PFO92"};